"use strict";
import ConsentManager from "src/decidim/data_consent/consent_manager";
const CONSENT_EXEMPT_HOSTS = ["www.youtube-nocookie.com", "youtube-nocookie.com"];
export const isConsentExemptIframe = (iframe) => {
  const src = iframe.getAttribute("src");
  if (!src) {
    return false;
  }
  try {
    const { hostname } = new URL(src, window.location.href);
    return CONSENT_EXEMPT_HOSTS.includes(hostname);
  } catch (error) {
    return false;
  }
};
const originalTriggerIframes = ConsentManager.prototype.triggerIframes;
ConsentManager.prototype.triggerIframes = function() {
  if (this.allAccepted()) {
    Reflect.apply(originalTriggerIframes, this, []);
    return;
  }
  document.querySelectorAll("iframe").forEach((original) => {
    if (isConsentExemptIframe(original)) {
      return;
    }
    const newElement = document.createElement("div");
    newElement.className = "disabled-iframe";
    newElement.appendChild(document.createComment(`${original.outerHTML}`));
    original.parentNode.replaceChild(newElement, original);
  });
};
